import { productsMatcher } from "../../../utils/productsMatcher";
import { getBlockedProductIdsForSelectedIds } from "../../../common/onBoardingWizardFieldTypes/cameraProductsMutualExclusion";

export const handleSelectAllClick = (
  camerasObject: any,
  setCamerasObject: any,
  productName: any,
  checked: boolean,
  checkboxesChecked: any,
  setCheckBoxesChecked: any,
  productsArray: any
) => {
  const productId = productsMatcher("Id", productName, productsArray);
  if (productId === undefined || productId === null) {
    return;
  }

  const updatedCheckboxes: any = {
    ...checkboxesChecked,
    [productName]: checked,
  };
  const updatedCamerasObject: any = { ...camerasObject };

  for (const key in camerasObject) {
    const returnObject = { ...camerasObject[key] };
    const currentProducts = [...(camerasObject[key].products || [])];
    const rowCheckboxKey = `${productName}${key}`;

    if (checked) {
      const blockedProductIds = getBlockedProductIdsForSelectedIds(
        currentProducts,
        productsArray
      );
      if (blockedProductIds.has(productId)) {
        updatedCheckboxes[rowCheckboxKey] = false;
      } else if (!currentProducts.includes(productId)) {
        returnObject.products = [...currentProducts, productId];
        updatedCamerasObject[key] = returnObject;
        updatedCheckboxes[rowCheckboxKey] = true;
      } else {
        updatedCheckboxes[rowCheckboxKey] = true;
      }
    } else {
      const returnArray = currentProducts.filter(
        (num: number) => num !== productId
      );
      returnObject.products = returnArray;
      updatedCamerasObject[key] = returnObject;
      updatedCheckboxes[rowCheckboxKey] = false;
    }
  }

  setCamerasObject(updatedCamerasObject);
  setCheckBoxesChecked(updatedCheckboxes);
};
